import uuidv4 from '@/util/uuidv4';
import { ISSUE_PRIORITY } from '@/constants';

export default {
    actionIssue: ({
        title = '',
        description = '',
        suggestedCorrectiveAction = '',
        priority = ISSUE_PRIORITY.MEDIUM,
        assignees = null,
        deadline = null,
        site = null,
        photos = null,
    } = {}) => ({
        uuid: uuidv4(),
        type: 'action',
        action: 'issue',
        visible_for_conductor: true,
        executed_at: null,
        params: {
            title,
            description,
            suggested_corrective_action: suggestedCorrectiveAction,
            deadline,
            priority,
            site,
            photos,
            assignees: {
                users: assignees,
                groups: null,
                roles: null,
                sites: null,
                administrators: false,
            },
        },
    }),
};
